"use strict";
/*
    The dropdown's tabindex="-1" steals keyboard focus on option click, which
    Selectize doesn't detect. Patched into Selectize.prototype.setup so it covers every instance, including ones created
    via jQuery's $.fn.selectize() directly.
 */
(function () {
  var originalSetup = Selectize.prototype.setup;
  Selectize.prototype.setup = function () {
    originalSetup.apply(this, arguments);
    this.$dropdown.on('mousedown', function (e) {
      e.preventDefault();
    });
  };
})();


/*
    Selectize plugin to fix a major UX problem with Selectize: allow selection
    of an empty option.

    By default, Selectize converts this:
       <option value="">----</option>
    to this:
       <input ... placeholder="----">

    ...and removes the original empty option from the dropdown. This has the
    effect of making it impossible to click on the empty option; users must use the
    delete key.

    Background:
    https://github.com/brianreavis/selectize.js/issues/163

    Usage:
      $('#element').selectize({
        plugins: {'selectable_placeholder': {}}
      });
 */
Selectize.define('selectable_placeholder', function (options) {
  // When a generated action method explicitly returns an empty option,
  // selectize does not remove it. In such cases, we need to avoid duplicate values
  // from being inserted. For more information about this issue, refer to
  // https://cloudbolt.atlassian.net/browse/ENG-24205?focusedCommentId=425759

  for (let key in this.options) {
    let val = this.options[key].value;
    if (val === null || val === '') // an empty option is already in the list
      return;
  }

  var self = this,
      $origInput = self.$input,
      // this plugin only works for select elements
      $emptyOption = $origInput.children('option[value=""]');

  if ($emptyOption.length === 0) {
    // do not apply this plugin; there is no empty option in the original select
    return;
  }

  options = $.extend({
    placeholder: self.settings.placeholder,
    html: function (data) {
      return (
        '<div class="selectize-dropdown-content placeholder-container">' +
        '<div data-selectable class="option">' + escape_html(data.placeholder) + '</div>' +
        '</div>');
    }
  }, options);

  // override the setup method to add an extra "click" handler
  self.setup = (function () {
    var original = self.setup;
    return function () {
      original.apply(this, arguments);
      self.$placeholder_container = $(options.html(options));
      self.$dropdown.prepend(self.$placeholder_container);
      self.$dropdown.on('click', '.placeholder-container', function () {
        self.setValue('');
        self.close();
        self.blur();
      });
    };
  })();

});


/**
 * Plugin: "remove_button" (selectize.js)
 * Copyright (c) 2013 Brian Reavis & contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 * @author Brian Reavis <brian@thirdroute.com>
 */

/**
 * (from selectize utils.js)
 * Escapes a string for use within HTML.
 *
 * @param {string} str
 * @returns {string}
 */
var escape_html = function(str) {
  return (str + '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

Selectize.define('remove_button', function(userOptions) {
  if (this.settings.mode === 'single') return;

  var options = $.extend({
    label     : '<i class="fas fa-times"></i>',
    title     : gettext('Remove'),
    className : 'remove',
    append    : true
  }, userOptions);

  var self = this;
  var html = '<a href="javascript:void(0)" class="' + options.className + '" tabindex="-1" title="' + escape_html(options.title) + '">' + options.label + '</a>';

  /**
   * Appends an element as a child (with raw HTML).
   *
   * @param {string} html_container
   * @param {string} html_element
   * @return {string}
   */
  var append = function(html_container, html_element) {
    var pos = html_container.search(/(<\/[^>]+>\s*)$/);
    return html_container.substring(0, pos) + html_element + html_container.substring(pos);
  };

  this.setup = (function() {
    var original = self.setup;
    return function() {
      // override the item rendering method to add the button to each
      if (options.append) {
        var render_item = self.settings.render.item;
        self.settings.render.item = function(data) {
          return append(render_item.apply(this, arguments), html);
        };
      }

      original.apply(this, arguments);

      // add event listener
      this.$control.on('click', '.' + options.className, function(e) {
        e.preventDefault();
        if (self.isLocked) return;

        var $item = $(e.currentTarget).parent();
        self.setActiveItem($item);
        if (self.deleteSelection()) {
          self.setCaret(self.items.length);
        }
      });

    };
  })();

});


/**
 * Show buttons to select and clear all options.  Only works for
 * multiple-select mode.
 */
Selectize.define('batch_toolbar', function(userOptions) {
  if (this.settings.mode === 'single') return;

  var self = this;
  var options = $.extend({
    // speeds things up?
    skipChangeEvent: true,
    labelAll   : '<i class="bi bi-asterisk"></i>',
    labelClear : '<i class="fas fa-times"></i>',
    titleAll   : gettext('Select all items'),
    titleClear : gettext('Clear selection'),
  }, userOptions);


  var selectAllOptions = function(e) {
    e.preventDefault();
    if (self.isLocked) return;

    _.forEach(self.options, function (i) {
      self.addItem(i.value, options.skipChangeEvent);
    });
  };


  var clearAllOptions = function(e) {
    e.preventDefault();
    if (self.isLocked) return;

    self.clear(options.skipChangeEvent);
  };


  var $btnGroup = $('<div class="selectize-toolbar btn-group"></div>');
  var insertToolbar = function() {
    var $allBtn = $(
      '<button class="select-all-options btn btn-light btn-xs" data-bs-toggle="tooltip" title="' +
      escape_html(options.titleAll) + '">' + options.labelAll + '</button>')
      .on('click', selectAllOptions);

    var $clearBtn = $(
      '<button class="select-no-options btn btn-light btn-xs" data-bs-toggle="tooltip" title="' +
      escape_html(options.titleClear) + '">' + options.labelClear + '</button>')
      .on('click', clearAllOptions);

    $btnGroup.append($allBtn).append($clearBtn);
    $btnGroup.insertAfter(self.$control);
  };


  this.setup = (function() {
    var original = self.setup;
    return function() {
      original.apply(this, arguments);
      insertToolbar();
    };
  })();
});
